import { combineReducers } from 'redux';
import { loadingStateReducer } from '../utils';
import { UPDATE_DETAILS_BATCH, UPDATE_STATUS_BATCH, UPDATE_TARGET_BATCH } from './constants';

export default combineReducers({
  updateBatchDetailsStatus: loadingStateReducer(UPDATE_DETAILS_BATCH),
  updateBatchStatusStatus: loadingStateReducer(UPDATE_STATUS_BATCH),
  updateBatchTargetStatus: loadingStateReducer(UPDATE_TARGET_BATCH)
});
